import React, { FC, ReactNode } from 'react';
import { ErYesNoQuestion } from '../EssentialRewardsButton';

interface Props {
  onChange: (value: boolean) => void;
  value?: boolean;
  whenYes: ReactNode | string;
  whenNo: ReactNode | string;
  question: string;
  err?: boolean;
}
const isString = (value: any): value is string => typeof value === 'string';

export const YesNoQuestion: FC<Props> = ({ question, onChange, value, whenYes, whenNo, err }) => {
  let message: ReactNode | string = '';

  if (value === true) {
    message = whenYes;
  }
  if (value === false) {
    message = whenNo;
  }
  if (err === true) {
    message = '';
  }
  return (
    <>
      <p dangerouslySetInnerHTML={{ __html: question || '' }} />
      <div className="d-flex align-items-start mb-3">
        <ErYesNoQuestion value={value} onChange={(x: boolean) => onChange(x)} />
        <div>
          <p className="ml-3">
            {isString(message) ? (
              <span dangerouslySetInnerHTML={{ __html: String(message) }} />
            ) : (
              message
            )}
          </p> 
        </div>
      </div>
    </>
  );
};
